/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { useState } from "react";
import { ErrorCode, useDropzone } from "react-dropzone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { regular } from "cms/icons";
import { getDimensionsText } from "cms/images/image-selector/image-helpers";
import { useOrgSettings } from "hooks/use-org-settings";
// import { autoGenerateFileName, validateFileName } from "cms/files";

const { faXmark } = regular;

const FileDropArea = (props) => {
    
    const selectedImage = props?.selectedImage;
    const newFile = props?.newFile;
    const setNewFile = props?.setNewFile;
    const setIsUploaded = props?.setIsUploaded;
    const fileType = props?.fileType;

    const { getOrgSettingsNumber } = useOrgSettings();
    const uploadLimit = getOrgSettingsNumber("upload_limit"); // value in bytes
    const uploadLimitMB = Math.floor(uploadLimit/1000000);
    const fileTooLargeErrorMessage = `Error: File exceeds maximum size (${uploadLimitMB}MB). Please try again.`;
    const [fileError, setFileError] = useState(false);

    const { getRootProps, getInputProps } = useDropzone({
        onDrop: (acceptedFiles, rejectedFiles) => {
            setFileError(false);
            if (acceptedFiles.length > 0) {
                const _file = acceptedFiles[0];
                // let generatedFileName;
                // const isValidFileName = validateFileName(_file?.name, 'image')
                // if (isValidFileName) {
                //     generatedFileName = _file?.name
                // } else {
                //     generatedFileName = autoGenerateFileName(_file?.name)
                // }
                // const updatedFile = new File([_file], generatedFileName, { type: _file.type });
                const updatedFile = new File(
                    [_file],
                    _file?.name,
                    { type: fileType }
                );
                const fileWithPreview = Object.assign(
                    updatedFile, 
                    { preview: URL.createObjectURL(_file), }
                );
                setNewFile(fileWithPreview);
                setIsUploaded(true);
            }
            rejectedFiles.forEach((file) => {
                file.errors.forEach((error) => {
                    if (error.code === ErrorCode.FileTooLarge) {
                        setFileError(true);
                    }
                });
            });
        },
        accept: "image/*",
        maxFiles: 1,
        maxSize: uploadLimit,
        noClick: true
    });

    const handleRemoveImage = () => {
        setNewFile(null);
        setIsUploaded(false);
    };
    return (
        <div className="file-drop-area" {...getRootProps()}>
            <input {...getInputProps()} id="upload-input" className="file-input" />
            {newFile && (
                <div className="file-preview">
                    <img
                        src={newFile.preview}
                        alt="Selected"
                        className="preview-image"
                    />
                    <div className="file-info">
                        <p>{newFile.name}</p>
                        <p>Size: {(newFile.size / 1024).toFixed(1)} KB</p>
                        <p>Dimensions: {getDimensionsText(selectedImage)}</p>
                    </div>
                    <FontAwesomeIcon
                        icon={faXmark}
                        onClick={handleRemoveImage}
                        className="remove-img-icon"
                        aria-label="Remove image"
                    />
                </div>
            )}
            {!newFile && (
                <div className="file-drop-text">
                    Drag and drop, or{" "}
                    <label htmlFor="upload-input" className="select-image-label">
                        select an image
                    </label>
                    {fileError && <p className="file-error">{fileTooLargeErrorMessage}</p>}
                </div>
            )}
        </div>
    );
};

export { FileDropArea };
